<template>

    <div class="col-sm-12 mt-2">

        <div class="col-sm-12 d-flex panel p-0 pb-2 border-top-lightest border-left-lightest border-right-lightest justify-content-end">
            <button class="btn blue" @click="createRefundBtn">Create Refund</button>
        </div>

        <!-- content -->
        <div class="my-4">
            <refund-rows v-if="reservation.refunds.length > 0" :refunds="reservation.refunds"/>

            <div v-else class="text-center fs-large dark w-100">
                No refunds found
            </div>
        </div>

    </div>


</template>

<script>
import {eventHub} from '@/main'
import refundRows from '@/tools/modal/ReservationEdit/TabRefunds/refundRows'
export default {
    data: function() {
        return {

        }
    },
    props:{
        reservation:{
            type: Object
        }
    },
    methods: {

        createRefundBtn: function () {
            console.log('createRefundBtn');
            this.eventHub.$emit('refundReservation')
        }
    },
    components: {
        refundRows
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabRefunds.vue?503f770e